var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcArrowup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/16px/Arrow",
    transform: "rotate(180 9 8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 136",
    d: "M17 4L11.1213 9.87868C9.94975 11.0503 8.05025 11.0503 6.87868 9.87868L1 4",
    stroke: "#2C2C2C",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcArrowup);
export default __webpack_public_path__ + "static/media/ic_arrowup.93982a1c7d37f21f8697fa3705b3d9af.svg";
export { ForwardRef as ReactComponent };